var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAlarmCriticalEcho(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_alarm_critical_echo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_alarm_critical_echo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C60000",
    fill: "#FFFFFF",
    cx: 11,
    cy: 11,
    r: 8.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C60000",
    cx: 11,
    cy: 11,
    r: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)",
    fill: "#C60000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,6 C0,9.314 2.686,12 6,12 C9.314,12 12,9.314 12,6 C12,2.686 9.314,0 6,0 C2.686,0 0,2.686 0,6 Z",
    id: "Clip-2",
    transform: "translate(6.000000, 6.000000) rotate(-180.000000) translate(-6.000000, -6.000000) "
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8.826,11.272 L14.81,11.272 C14.832,11.206 14.843,11.129 14.843,10.986 C14.843,8.874 13.435,7.741 11.268,7.741 C8.947,7.741 7.561,8.995 7.561,10.997 C7.561,12.977 8.947,14.231 11.356,14.231 C12.764,14.231 13.809,13.89 14.634,13.153 L13.886,12.35 C13.226,12.933 12.533,13.219 11.422,13.219 C9.904,13.219 8.947,12.581 8.826,11.272 Z M11.279,8.753 C12.467,8.753 13.325,9.248 13.6,10.348 L8.881,10.359 C9.123,9.292 10.014,8.753 11.279,8.753 Z",
    id: "e",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlarmCriticalEcho);
export default __webpack_public_path__ + "static/media/icon_alarm_critical_echo.d488297daff1027410f59223c4fed109.svg";
export { ForwardRef as ReactComponent };